<template lang="pug">
    div(ref="lightgallery")
      slot
</template>

<script>
/* eslint no-undef:0 */
import "lightgallery.js"

export default {
  props: {
    options: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    defaultOptions () {
      return {
        thumbnail: false,
        animateThumb: false,
        showThumbByDefault: false,
        download: false,
        selector: '.item'
      }
    },

    lightgalleryOptions () {
      return {
        ...this.defaultOptions,
        ...this.options
      }
    }
  },
  mounted () {
    lightGallery(this.$refs.lightgallery, this.lightgalleryOptions)
  }
}
</script>
